//use effect and usestate
import React, { useState, useEffect } from 'react';
import Toast from './../LoadingError/Toast';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {updateUser} from './../../Redux/Actions/userActions';
import { toast } from 'react-toastify';
import Message from '../LoadingError/Error';
import Loading from '../LoadingError/Loading';








const EditClientMain = (props) => {


    const { user } = props;

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const[password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");




    useEffect(() => {

            if(user){
            setName(user.name);
            setEmail(user.email);
            }
    }, [user]);


    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();

       if(password !== confirmPassword){
              toast.error("Passwords do not match");
       }
       else if (password.length < 6){
              toast.error("Password must be at least 6 characters");
       }
         else{
           const userUpdated = {
               _id: user._id,
               name,
               email,
               password
           }
           dispatch(updateUser(userUpdated));
           //reset password fields
              setPassword("");
                setConfirmPassword("");
            }
    }





    return (
        <>
            <Toast />




            <section className="content-main" style={{ maxWidth: "1200px" }}>
                <form onSubmit={handleSubmit} >

                    <div className="content-header">
                        <Link to="/users" className="btn btn-danger text-white">
                            Go to Users
                        </Link>
                        <h2 className="content-title">Update User</h2>
                        <div>
                            <button type="submit" className="btn btn-primary">
                                Edit User
                            </button>
                        </div>
                    </div>


                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input type="text" className="form-control" id="name" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                {/*  password and confirm password*/}
                    <div className="form-group">
                        <label htmlFor="password">password</label>
                        <input type="password" className="form-control" id="password"
                        value={password} onChange={(e) => setPassword(e.target.value)} />

                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input type="password" className="form-control" id="confirmPassword"
                        value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />

                    </div>




                </form>
            </section>
        </>
    );
};

export default EditClientMain;
